import React, { useContext, useState, useEffect, useRef } from "react";
import api from "../../services/api";
import Navbar from "../../components/Navbar/Navbar";
import {
  Box,
  Flex,
  Text,
  Stack,
  Container,
  FormControl,
  Select,
  Input,
  FormLabel,
  Switch,
  Button,
  FormErrorMessage,
  useToast,
  VStack,
  HStack,
  IconButton,
  Grid,
} from "@chakra-ui/react";
import JoditEditor from "../../components/Editor";
import { UserContext } from "../../contexts/User";
import { OrderContext } from "../../contexts/Order";
import { environment } from "../../environment";
import { AddIcon, CloseIcon } from "@chakra-ui/icons";
export default function Budget() {
  const { listClientsApi } = useContext(UserContext);
  const { listTypesServiceApi } = useContext(OrderContext);
  const { createBudgetApi, calculateValueOrder } = useContext(OrderContext);
  const toast = useToast();
  const [clients, setClients] = useState([]);
  const [textAreaValue, setTextAreaValue] = useState("");
  const [title, setTitle] = useState("");
  const [client, setClient] = useState("");
  const [planID, setPlanID] = useState("");
  const [approvedMagazine, setApprovedMagazine] = useState(0);
  const [approvedMagazineName, setApprovedMagazineName] = useState("");
  const [numberWords, setNumberWords] = useState("");
  const [showAddClientForm, setShowAddClientForm] = useState(false);
  const [totalBudget, setTotalBudget] = useState();
  const [totalBudgetPix, setTotalBudgetPix] = useState();
  const [paymentLink, setPaymentLink] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [precoParcelamento, setPrecoParcelamento] = useState("");
  const [deadline, setDeadline] = useState("");
  const [errors, setErrors] = useState({});
  const [listTypesService, setListTypesService] = useState([]);
  const [numberParcelas, setNumberParcelas] = useState("");
  const maxValueCreditCardBudget6x = 5000;
  const userInfo = JSON.parse(localStorage.getItem("user"));
  const [errorsServices, setErrorsServices] = useState([]);
  const [fastDelivery, setFastDelivery] = useState(false);
  const [services, setServices] = useState([
    {
      language_origin: "",
      language_final: "",
      fast_delivery: false,
      fast_delivery_days: 0,
      fast_delivery_price: 0,
      plan_days: 0,
      plan_rate: 0,
      qty_figures: 0,
      total_figures: 0,
      magazine_name: "",
      magazine_edit: 0,
      edition_value_credit_card: 0,
      qty_references: 0,
      total_budget_order: 0,
      total_budget_order_pix: 0,
      total_reference: 0,
      edition_value: 0,
      deadline: 0,
      discount: 0,
      description: "",
      description_discount: "",
      details: "",
      value_discount: 0,
      total_budget_order_discount: 0,
      total_budget_order_discount_pix: 0,
      type_edition: null,
      type_service: 0,
      total_budget_order_no_edition: 0,
      reduced_days_fast: 0
    },
  ]);

  const handleAddService = () => {
    setServices([
      ...services,
      {
        language_origin: "",
        language_final: "",
        fast_delivery: false,
        fast_delivery_days: 0,
        fast_delivery_price: 0,
        plan_days: 0,
        plan_rate: 0,
        qty_figures: 0,
        total_figures: 0,
        magazine_name: "",
        magazine_edit: 0,
        edition_value_credit_card: 0,
        qty_references: 0,
        total_budget_order: 0,
        total_budget_order_pix: 0,
        total_reference: 0,
        edition_value: 0,
        deadline: 0,
        discount: 0,
        description: "",
        description_discount: "",
        details: "",
        value_discount: 0,
        total_budget_order_discount: 0,
        total_budget_order_discount_pix: 0,
        type_edition: null,
        type_service: 0,
        total_budget_order_no_edition: 0,
        reduced_days_fast: 0
      },
    ]);
  };

  const validateService = (service) => {
    const currentErrors = {};
  
    if (!service.type_service) currentErrors.typeService = true;
  
    if (service.type_service != 4) {
      if (!service.plan_rate) currentErrors.planRate = true;
      if (!service.deadline) currentErrors.deadline = true;
      if (!service.plan_days) currentErrors.planDays = true;
  
      if (service.fast_delivery) {
        if (!service.fast_delivery_price) currentErrors.fastDeliveryPrice = true;
        if (!service.fast_delivery_days) currentErrors.fastDeliveryDays = true;
      }
    } else {
      if (!service.qty_references) currentErrors.qtyReferences = true;
    }
  
    if (!service.language_origin) currentErrors.languageOrigin = true;
    if (!service.language_final) currentErrors.languageFinal = true;
  
    if (service.magazine_edit == 1) {
      if (!service.type_edition) currentErrors.typeEdition = true;
      if (!service.magazine_name) currentErrors.magazineName = true;
    }
  
    if (service.discount == 1 && !service.value_discount) {
      currentErrors.discountValue = true;
    }
    return currentErrors;
  };
  
  const handleRemoveService = (index) => {
    console.log("remover", index);
    const updatedServices = services.filter((_, i) => i !== index);
    setServices(updatedServices);
  };

  const handleServiceChange = (index, field, value) => {
    setServices((prev) => {
      const updated = [...prev];
      updated[index][field] = value;
      return updated;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(services);
  };

  const handleInputTitle = (e) => {
    const value = e.target.value;
    setTitle(value);
  };
  
  const handleInputClientID = (event) => {
    const selectedValue = event.target.value;
    setClient(selectedValue);
    const selectedClient = clientOptions.find(
      (client) => String(client.value) === selectedValue
    );
    setName(selectedClient.label);
  };
  const  calculateDaysDeadline = async () => {
    const daysTotal = services.reduce((total, service) => {
      const value = Number(service.deadline) || 0;
      return total + value;
    }, 0);
    
    setDeadline(daysTotal);
  };
  const calculateTotalBudget = () => {
    return services.reduce((total, service) => {
      const value = service.discount == 1 
        ? service.total_budget_order_discount
        : service.total_budget_order;
      return total + (value || 0);
    }, 0);
  };
  const calculateTotalBudgetPix = () => {
    return services.reduce((total, service) => {
      const value = service.discount == 1 
        ? service.total_budget_order_discount_pix 
        : service.total_budget_order_pix;
      return total + (value || 0);
    }, 0);
  };
  const calcularParcelamento = (totalBudget) => {
    if (totalBudget <= maxValueCreditCardBudget6x) {
      setPrecoParcelamento(totalBudget / 6);
      setNumberParcelas(6);
    } else {
      setPrecoParcelamento(totalBudget / 12);
      setNumberParcelas(12);
    }
  };

  const calculateTotal = async () => {
    const total = calculateTotalBudget();
    const totalPix = calculateTotalBudgetPix();
    setTotalBudgetPix(totalPix);
    setTotalBudget(total);
    calcularParcelamento(total);
  };
  const handleInputApprovedMagazineName = (e) =>
    setApprovedMagazineName(e.target.value);
  const handleInputApprovedMagazine = (e) =>
    setApprovedMagazine(e.target.value);

  const getPrices = async (plan_id, type_service) => {
    try {
      const token = localStorage.getItem("token");
      const response = await api.get(
        `plans/plan-prices/${plan_id}/${type_service}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const planPrice = response.data?.[0];
      return planPrice;
      
    } catch (error) {
      console.error(error);
    }
  };
  const typesServicesOptions = listTypesService.map((type) => ({
    value: type.id,
    label: type.name,
  }));
  const getDetailsServiceText = (plano, servico) =>{
    if(plano == 1 && (servico == 1 || servico == 2)){
      return `<strong>Serviços inclusos no plano BASIC: </strong>3 (três) níveis de revisão/tradução para o inglês científico usando plain english, correção da gramática, pontuação no texto e em números e consistência dos números e termos de acordo com literatura da área. <u>No entanto, a rodada de correção não está inclusa.</u>`
    } else if (plano == 2 && (servico == 1 || servico == 2)){
      return `<strong>Serviços inclusos no plano PRO:</strong> 3 (três) níveis de revisão/tradução para o inglês científico usando plain english e com correção da gramática, pontuação no texto e números, consistência dos números no texto e termos de acordo com literatura da área, síntese, análise de plágio, estrutura textual, fluidez, coesão, coerência, precisão, estilo de escrita científica, revisão por pares (com sugestões de melhoria) e uma rodada de correção (opcional).`
    } else if (plano == 3 && (servico == 1 || servico == 2)){
      return `<strong>Serviços inclusos no plano FULL:</strong> 3 (três) níveis de revisão/tradução para o inglês científico usando plain english e com correção da gramática, pontuação no texto e números, consistência dos números no texto e termos de acordo com literatura da área, síntese, análise de plágio, estrutura textual, fluidez, coesão, coerência, precisão, estilo de escrita científica, revisão por pares (com sugestões de melhoria), uma rodada de correção (opcional) e edição nas normas da revista.`
    } else if (servico == 3){
      return `<strong>Serviços inclusos na Revisão do Português (Basic):</strong> evisão do texto para correção da gramática, pontuação no texto e números, consistência dos números no texto e dos termos de acordo com a literatura da área e estilo de escrita científica. <u> A rodada de correção não está inclusa.</u>`
    } else {
      return "";
    }
  }
  const handleTypeServiceSelect = async (event, index, fDelivery) => {
    const selectedOption = event.target.value;

    let plan_id = planID;
    if (selectedOption == 3) {
      plan_id = 1;
    } else if (selectedOption == 4) {
      plan_id = null;
      handleServiceChange(index, "deadline", 5);
      handleServiceChange(index, "magazine_edit", 1);
    }
    if (plan_id > 0) {
      const pricePlans = await getPrices(plan_id, selectedOption);
      if (pricePlans) {
        handleServiceChange(index, "plan_rate", pricePlans.price_word);
        if (fDelivery) {
          handleServiceChange(
            index,
            "fast_delivery_price",
            pricePlans.price_word_fastdelivery
          );
        }
        handleServiceChange(index, "deadline", pricePlans.days_to_finish);
        handleServiceChange(index, "plan_days", pricePlans.days_to_finish);
      }
    }
    handleServiceChange(index, "type_service", selectedOption);
    const selectedType = typesServicesOptions.find(
      (type) => type.value == selectedOption
    );
    if (selectedType) {
      handleServiceChange(index, "description", selectedType.label);
    }
    const detailsText = getDetailsServiceText(planID, selectedOption);
    handleServiceChange(index, "details", detailsText);
    await calculateDaysDeadline();
  };

  const handleInputPlanID = (e) => {
    const newPlanID = e.target.value;
    setPlanID(newPlanID);
    if (newPlanID == 1) {
    } else if (newPlanID == 2) {
    } else if (newPlanID == 3) {
    }
  };
  const handleInputNumberWords = (e) => {
    setNumberWords(e.target.value);
  } 
  const handleInputPaymentLink = (e) => setPaymentLink(e.target.value);
  const handleBlurAreaChange = (content) => {
    setTextAreaValue(content);
  };

  async function listClients() {
    try {
      const clients = await listClientsApi();
      const clientsOrdered = [...clients.data?.[0]]?.sort((a, b) => {
        const nameA = a.user?.name?.toLowerCase() || "";
        const nameB = b.user?.name?.toLowerCase() || "";
        return nameA.localeCompare(nameB);
      });
      setClients(clientsOrdered);
    } catch (error) {
      console.log(error);
    }
  }
  const clientOptions = clients.map((client) => ({
    value: client.id,
    label: client.user.name,
  }));
  async function getTypesService() {
    try {
      const typesServices = await listTypesServiceApi();
      setListTypesService(typesServices.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  }
  const handleSwitchChange = () => {
    setShowAddClientForm(!showAddClientForm);
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    let newErrors = { ...errors };
    if (!value) {
      newErrors.email = true;
      newErrors.emailFormat = false;
    } else {
      newErrors.email = false;
      newErrors.emailFormat = !value.includes("@");
    }
    setErrors(newErrors);
  };
  const calculateService = async (index) => {
    const service = services[index];
    const totalValueWords = numberWords * service.plan_rate;
    const data = {
      words: numberWords,
      plan: planID,
      magazine_edit: service.magazine_edit,
      type_edition: service.type_edition === 0 ? null : service.type_edition,
      plan_rate: service.plan_rate,
      fast_delivery: service.fast_delivery,
      fast_delivery_price: service.fast_delivery_price,
      fast_delivery_days: service.fast_delivery_days,
      qty_references: service.qty_references,
      type_service: service.type_service,
      discount: service.discount,
      value_discount: service.value_discount
    };
    try {
      const valueServico = await calculateValueOrder(data);
      handleServiceChange(
        index,
        "total_budget_order",
        valueServico.data?.[0].valueCreditCard
      );
      handleServiceChange(
        index,
        "total_budget_order_pix",
        valueServico.data?.[0].value
      );
      handleServiceChange(
        index,
        "total_budget_order_discount",
        valueServico.data?.[0].total_budget_order_discount
      );
      handleServiceChange(
        index,
        "total_budget_order_discount_pix",
        valueServico.data?.[0].total_budget_order_discount_pix
      );
      handleServiceChange(
        index,
        "edition_value",
        valueServico.data?.[0].editonValue
      );
      handleServiceChange(
        index,
        "edition_value_credit_card",
        valueServico.data?.[0].editionCreditCard
      );
      handleServiceChange(
        index,
        "total_budget_order_no_edition",
        valueServico.data?.[0].valueNoEditionCreditCard
      );
      handleServiceChange(
        index,
        "reduced_days_fast",
        valueServico.data?.[0].reduced_days_fast
      );
      handleServiceChange(
        index,
        "total_reference",
        valueServico.data?.[0].total_reference
      );
      handleServiceChange(
        index,
        "total_words",
        totalValueWords
      );
      
    } catch (error) {
      console.log(error);
      setTotalBudgetPix(0);
      setTotalBudget(0);
      toast({
        title: "Erro ao Calcular o Orçamento",
        status: "error",
        isClosable: true,
      });
    }
  };

  const handleGenerateData = async () => {
    let newErrors = {};
    if (!title) newErrors.title = true;
    if (!planID) newErrors.planID = true;
    if (!client && !showAddClientForm) newErrors.client = true;
    if (!numberWords) newErrors.numberWords = true;
    if (showAddClientForm) {
      if (!email) {
        newErrors.email = true;
      } else if (!email.includes("@")) {
        newErrors.emailFormat = true;
      }
      if (!name) newErrors.name = true;
      if (!phone) newErrors.phone = true;
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast({
        title: "Por favor, preencha todos os campos.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }
    if (
      services.length == 1 &&
      (services[0].type_service == 3 || services[0].type_service == 4) &&
      planID != 1
    ) {
      toast({
        title: "Os serviços de tipo Revisão do Portugês ou Edição de Normas(Individual) só estão disponíveis no plano Basic.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
      return;
    }
    const data = {
      title: title,
      add_client: showAddClientForm,
      abstract: textAreaValue,
      user_id: userInfo.id,
      client_id: client,
      plan_id: planID,
      words_number_original: numberWords,
      total_budget: totalBudget,
      total_budget_pix: totalBudgetPix,
      payment_link: paymentLink,
      deadline: deadline,
      name: name,
      email: email,
      whatsapp: phone,
      street_address: address,
      num_parcelas: numberParcelas,
      parcela_budget: precoParcelamento,
      approved_in_magazine: approvedMagazine,
      approved_magazine_name: approvedMagazineName,
      servicos: services
    };

    try {
      const responseData = await createBudgetApi(data);

      if (responseData.status === 202) {
        toast({
          title: "Orçamento criado com sucesso",
          status: "warning",
          duration: 7000,
          isClosable: true,
        });
      }
      const url = `${environment.baseURL}/storage/budgets/${responseData.data?.[0]?.pdf_path}`;
      window.open(url, "_blank");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      toast({
        title:
          "Não foi possível criar o serviço, verifique os campos e tente novamente",
        status: "error",
        duration: 7000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    listClients();
    getTypesService();
  }, []);

  useEffect(() => {
    const daysTotal = services.reduce((total, service) => {
      const value = Number(service.deadline) || 0;
      return total + value;
    }, 0);
  
    setDeadline(daysTotal);
  }, [services]);
  
  return (
    <>
      <Navbar />
      <Container
        position={"absolute"}
        top={120}
        ml={270}
        maxWidth={"80vw"}
        py={5}
      >
        <Box>
          {showAddClientForm && (
            <Box
              bg={"#ffff"}
              borderRadius={"15px "}
              boxShadow={"0px 7px 16px 4px #EAEAEA"}
              p={5}
              maxWidth={"100%"}
              mb={5}
            >
              <Text fontSize={"18px"} my={5}>
                Adicionar novo cliente
              </Text>
              {/* Formulário para adicionar novo cliente */}
              <FormControl my={2} isInvalid={errors.name} isRequired>
                <FormLabel>Nome</FormLabel>
                <Input
                  placeholder="Nome"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <FormErrorMessage>Campo obrigatório</FormErrorMessage>
              </FormControl>
              <FormControl
                my={2}
                isInvalid={errors.emailFormat || errors.email}
                isRequired
              >
                <FormLabel>Email</FormLabel>
                <Input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={handleEmailChange}
                />
                {errors.email ? (
                  <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                ) : errors.emailFormat ? (
                  <FormErrorMessage>
                    O e-mail deve conter o caractere '@'.
                  </FormErrorMessage>
                ) : null}
              </FormControl>
              <FormControl my={2} isInvalid={errors.phone} isRequired>
                <FormLabel>Telefone</FormLabel>
                <Input
                  placeholder="Telefone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
                <FormErrorMessage>Campo obrigatório</FormErrorMessage>
              </FormControl>
              <FormControl my={2}>
                <FormLabel>Endereço</FormLabel>
                <Input
                  placeholder="Endereço"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </FormControl>
            </Box>
          )}
        </Box>
        {/** FORMULÁRIO ORÇAMENTO APENAS */}
        <Box
          bg={"#ffff"}
          borderRadius={"15px "}
          boxShadow={"0px 7px 16px 4px #EAEAEA"}
          p={5}
          maxWidth={"100%"}
        >
          <Text marginBottom={"15px"} fontSize={18}>
            Informações Gerais sobre o Orçamento
          </Text>
          <Box>
            <FormControl display="flex" alignItems="center" pb={2}>
              <FormLabel mb="0">Adicionar novo cliente ?</FormLabel>
              <Switch onChange={handleSwitchChange} />
            </FormControl>
            {!showAddClientForm ? (
              <FormControl
                display="block"
                marginBottom="18px"
                isInvalid={errors.client}
              >
                {clients && (
                  <Select
                    onChange={handleInputClientID}
                    placeholder="Selecione um cliente"
                  >
                    {clientOptions.map((client, id) => (
                      <option key={id} value={client.value}>
                        {client.label}
                      </option>
                    ))}
                  </Select>
                )}
                <FormErrorMessage>Campo obrigatório</FormErrorMessage>
              </FormControl>
            ) : null}
            <FormControl
              display="block"
              marginTop="2%"
              isInvalid={errors.title}
              isRequired
            >
              <FormLabel>Adicione aqui o titulo do Serviço </FormLabel>
              <Input onChange={handleInputTitle} placeholder="Titulo" />
              <FormErrorMessage>Campo obrigatório</FormErrorMessage>
            </FormControl>
            <Stack margin="15px 0">
              <Text>Adicione aqui o Abstract </Text>
            </Stack>
            <FormControl>
              <JoditEditor
                onBlur={handleBlurAreaChange}
                value={textAreaValue}
              />
            </FormControl>
            <FormControl display="inline-flex" marginTop="2%" marginBottom="2%">
              <Text>Adicione aqui o link de pagamento </Text>
              <Input
                value={paymentLink}
                onChange={handleInputPaymentLink}
                placeholder="Adicione o link de pagamento"
              />
            </FormControl>
          </Box>
          <Flex alignItems="center" gap="1%" marginTop="1%">
            <FormControl isInvalid={errors.planID}>
              <FormLabel>Plano</FormLabel>
              <Select
                value={planID}
                onChange={handleInputPlanID}
                placeholder="Selecione um plano"
              >
                <option value={1}>Basic</option>
                <option value={2}>Pro</option>
                <option value={3}>Full</option>
              </Select>
              <FormErrorMessage>Campo obrigatório</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors.numberWords}>
              <FormLabel>Coloque a quantidade de palavras</FormLabel>
              <Input
                value={numberWords}
                type="number"
                onChange={(e) => handleInputNumberWords(e)}
              />
              <FormErrorMessage>Campo obrigatório</FormErrorMessage>
            </FormControl>
          </Flex>
          <Flex alignItems="center" gap="1%" marginTop="1%">
            <FormControl marginY="2%">
              <FormLabel>Já foi aprovado em revista?</FormLabel>
              <Select
                display="inline-block"
                width={"40%"}
                value={approvedMagazine}
                placeholder="Já foi aprovado em revista?"
                onChange={handleInputApprovedMagazine}
              >
                <option value="1">Sim</option>
                <option value="0">Não</option>
              </Select>

              {approvedMagazine == 1 && (
                <Flex alignItems="center" gap="1%" marginTop="1%">
                  <FormControl flex="1">
                    <Input
                      placeholder={"Nome da Revista*"}
                      onChange={handleInputApprovedMagazineName}
                    />
                    <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                  </FormControl>
                </Flex>
              )}
            </FormControl>
          </Flex>
          <Text marginTop={"20px"} marginBottom={"20px"} fontSize={18}>
            Serviços do Orçamento
          </Text>
          {/**Informações do Serviço */}
          <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
              {services.map((service, index) => (
                <Box
                  key={index}
                  bg="#ffff"
                  borderRadius="15px"
                  boxShadow="0px 7px 16px 4px #EAEAEA"
                  p={5}
                  maxWidth="100%"
                  mb={5}
                >
                  <Text fontWeight="bold">Serviço {index + 1}</Text>
                  <Grid
                    templateColumns="repeat(auto-fit, minmax(250px, 1fr))"
                    gap={4}
                    alignItems="flex-end"
                  >
                    <FormControl>
                      <FormLabel mb="0">O serviço é FastDelivery?</FormLabel>
                      <Switch
                        isChecked={service.fast_delivery}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          handleServiceChange(index, "fast_delivery", checked);
                          setFastDelivery(checked);
                        }}
                        colorScheme="green"
                      />
                    </FormControl>
                    <FormControl
                      isInvalid={errorsServices[index]?.typeService}
                      isRequired
                    >
                      <FormLabel>Selecione o Tipo de Serviço</FormLabel>
                      {listTypesService && (
                        <Select
                          value={service.type_service}
                          onChange={(e) => {
                            handleTypeServiceSelect(
                              e,
                              index,
                              service.fast_delivery
                            );
                          }}
                          placeholder="Selecione o Tipo de Serviço"
                        >
                          {typesServicesOptions.map((type, id) => (
                            <option key={id} value={type.value}>
                              {type.label}
                            </option>
                          ))}
                        </Select>
                      )}
                      <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                    </FormControl>
                    {service.type_service != 4 && (
                      <>
                        <FormControl>
                          <FormLabel>
                            O preço por palavra desse serviço será:
                          </FormLabel>
                          <Input
                            type="number"
                            value={service.plan_rate}
                            onChange={(e) =>
                              handleServiceChange(
                                index,
                                "plan_rate",
                                e.target.value
                              )
                            }
                          />
                          <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Prazo (dias) pelo plano:</FormLabel>
                          <Input
                            type="number"
                            value={service.plan_days}
                            onChange={(e) =>
                              handleServiceChange(
                                index,
                                "plan_days",
                                e.target.value
                              )
                            }
                          />
                          <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                        </FormControl>
                        {service.fast_delivery && (
                          <>
                            <FormControl
                              isInvalid={
                                errorsServices[index]?.fastDeliveryPrice
                              }
                              isRequired={service.fast_delivery}
                            >
                              <FormLabel>
                                O preço por palavra fast delivery:
                              </FormLabel>
                              <Input
                                type="number"
                                value={service.fast_delivery_price}
                                onChange={(e) =>
                                  handleServiceChange(
                                    index,
                                    "fast_delivery_price",
                                    e.target.value
                                  )
                                }
                              />
                              <FormErrorMessage>
                                Campo obrigatório
                              </FormErrorMessage>
                            </FormControl>

                            <FormControl
                              isInvalid={
                                errorsServices[index]?.fastDeliveryDays
                              }
                              isRequired={service.fast_delivery}
                            >
                              <FormLabel>
                                Em quantos dias deverá ser entregue?
                              </FormLabel>
                              <Input
                                type="number"
                                onChange={(e) =>
                                  handleServiceChange(
                                    index,
                                    "fast_delivery_days",
                                    e.target.value
                                  )
                                }
                              />
                              <FormErrorMessage>
                                Campo obrigatório
                              </FormErrorMessage>
                            </FormControl>
                          </>
                        )}
                      </>
                    )}
                    <FormControl>
                      <FormLabel>Entrega do Serviço (Dias):</FormLabel>
                      <Input
                        type="number"
                        value={service.deadline}
                        onChange={(e) =>{
                          handleServiceChange(index, "deadline", e.target.value);
                          calculateDaysDeadline();
                        }
                        }
                      />
                      <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={errorsServices[index]?.qtyReferences}
                      isRequired={service.type_service == 4}
                      flex="1"
                    >
                      <FormLabel>Coloque a quantidade de referências</FormLabel>
                      <Input
                        type="number"
                        onChange={(e) =>
                          handleServiceChange(
                            index,
                            "qty_references",
                            e.target.value
                          )
                        }
                      />
                      <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                    </FormControl>
                    <FormControl flex="1">
                      <FormLabel>Coloque a quantidade de figuras</FormLabel>
                      <Input
                        type="number"
                        onChange={(e) =>
                          handleServiceChange(
                            index,
                            "qty_figures",
                            e.target.value
                          )
                        }
                      />
                    </FormControl>

                    <FormControl
                      isInvalid={errorsServices[index]?.languageOrigin}
                      isRequired
                    >
                      <FormLabel>Selecione a língua de origem</FormLabel>
                      <Select
                        value={service.language_origin}
                        onChange={(e) =>
                          handleServiceChange(
                            index,
                            "language_origin",
                            e.target.value
                          )
                        }
                        placeholder="Selecione a língua do texto"
                      >
                        <option value="PT">Português</option>
                        <option value="EN">Inglês</option>
                        <option value="ESP">Espanhol</option>
                      </Select>
                      <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                    </FormControl>

                    <FormControl
                      isInvalid={errorsServices[index]?.languageFinal}
                      isRequired
                    >
                      <FormLabel>Selecione a língua final</FormLabel>
                      <Select
                        value={service.language_final}
                        onChange={(e) =>
                          handleServiceChange(
                            index,
                            "language_final",
                            e.target.value
                          )
                        }
                        placeholder="Selecione a língua do texto"
                      >
                        <option value="PT">Português</option>
                        <option value="EN">Inglês</option>
                        <option value="ESP">Espanhol</option>
                      </Select>
                      <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                    </FormControl>

                    {service.type_service != 4 && (
                      <>
                        <FormControl>
                          <FormLabel>Edição das normas da Revista</FormLabel>
                          <Select
                            width="100%"
                            value={service.magazine_edit}
                            placeholder="Edição das normas da Revista"
                            onChange={(e) =>
                              handleServiceChange(
                                index,
                                "magazine_edit",
                                e.target.value
                              )
                            }
                          >
                            <option value="1">Sim</option>
                            <option value="0">Não</option>
                          </Select>
                        </FormControl>
                      </>
                    )}

                    {service.magazine_edit == 1 && (
                      <>
                        <FormControl
                          flex="1"
                          isInvalid={errorsServices[index]?.typeEdition}
                          isRequired={service.magazine_edit == 1}
                        >
                          <FormLabel>
                            Selecione o tipo da edição de normas
                          </FormLabel>
                          <Select
                            onChange={(e) =>
                              handleServiceChange(
                                index,
                                "type_edition",
                                e.target.value
                              )
                            }
                            placeholder="Selecione o Tipo da Edição"
                          >
                            <option value="1">Artigo</option>
                            <option value="2">Dissertação/Tese</option>
                          </Select>
                          <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                        </FormControl>

                        <FormControl
                          flex="1"
                          isInvalid={errorsServices[index]?.magazineName}
                          isRequired={service.magazine_edit == 1}
                        >
                          <FormLabel>Nome da Revista</FormLabel>
                          <Input
                            placeholder={
                              service.type_edition == 1
                                ? "Nome da Revista*"
                                : "Link para as normas ou Estilo*"
                            }
                            onChange={(e) =>
                              handleServiceChange(
                                index,
                                "magazine_name",
                                e.target.value
                              )
                            }
                          />
                          <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                        </FormControl>
                      </>
                    )}
                    <>
                      <FormControl>
                        <FormLabel>Deseja aplicar um desconto?</FormLabel>
                        <Select
                          width="100%"
                          value={service.discount}
                          placeholder="Desconto"
                          onChange={(e) =>
                            handleServiceChange(
                              index,
                              "discount",
                              e.target.value
                            )
                          }
                        >
                          <option value="1">Sim</option>
                          <option value="0">Não</option>
                        </Select>
                      </FormControl>
                    </>
                    {service.discount == 1 && (
                      <>
                        <FormControl flex="1">
                          <FormLabel>Valor do desconto? (Percentual)</FormLabel>
                          <Input
                            placeholder={"Percentual"}
                            onChange={(e) =>
                              handleServiceChange(
                                index,
                                "value_discount",
                                e.target.value
                              )
                            }
                          />
                          <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                        </FormControl>
                        <FormControl>
                          <FormLabel>Descrição do Desconto</FormLabel>
                          <Input
                            placeholder={"Descrição do Desconto"}
                            onChange={(e) =>
                              handleServiceChange(
                                index,
                                "description_discount",
                                e.target.value
                              )
                            }
                          />
                          <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                        </FormControl>
                      </>
                    )}
                    <FormControl>
                      <FormLabel>Descrição do Serviço</FormLabel>
                      <Input
                        value={service.description}
                        placeholder={"Descrição do Serviço"}
                        onChange={(e) =>
                          handleServiceChange(
                            index,
                            "description",
                            e.target.value
                          )
                        }
                      />
                      <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                    </FormControl>
                    <FormControl gridColumn="1 / -1">
                      <FormLabel>Detalhes do Serviço</FormLabel>
                      <JoditEditor
                        value={service.details || ""}
                        onChange={(newContent) =>
                          handleServiceChange(index, "details", newContent)
                        }
                      />
                      <FormErrorMessage>Campo obrigatório</FormErrorMessage>
                    </FormControl>

                    {services.length > 1 && (
                      <Button
                        aria-label="Remover serviço"
                        size="sm"
                        colorScheme="red"
                        onClick={() => handleRemoveService(index)}
                        ml={2}
                      >
                        Remover
                      </Button>
                    )}
                  </Grid>
                  <Box mt={4} p={4} bg="gray.50" borderRadius="md">
                    <VStack spacing={4} align="flex-start">
                      <Button
                        colorScheme="green"
                        onClick={() => {
                          const validationErrors = validateService(service);
                          const newErrors = [...errorsServices];
                          newErrors[index] = validationErrors;
                          setErrorsServices(newErrors);
                          
                          if (Object.keys(validationErrors).length > 0) {
                            toast({
                              title: "Campos obrigatórios não preenchidos",
                              status: "warning",
                              duration: 5000,
                              isClosable: true,
                            });
                            return;
                          }
                          calculateService(index);
                        }}
                      >
                        Calcular Serviço
                      </Button>

                      {service.total_budget_order > 0 &&
                        service.total_budget_order_pix > 0 && (
                          <VStack spacing={3} align="flex-start" width="100%">
                            {service.type_service != 4 && (
                              <>
                                {service.magazine_edit == 1 &&
                                  service.type_edition && (
                                    <>
                                      <Text fontSize="sm">
                                        Valor do Serviço:{" "}
                                        <Text as="span" fontWeight="bold">
                                          {service.total_budget_order_no_edition?.toLocaleString(
                                            "pt-BR",
                                            {
                                              style: "currency",
                                              currency: "BRL",
                                            }
                                          )}
                                        </Text>{" "}
                                        (Cartão de crédito)
                                      </Text>

                                      <Text fontSize="sm">
                                        Valor da Edição:{" "}
                                        <Text as="span" fontWeight="bold">
                                          {service.edition_value_credit_card?.toLocaleString(
                                            "pt-BR",
                                            {
                                              style: "currency",
                                              currency: "BRL",
                                            }
                                          )}
                                        </Text>{" "}
                                        (Cartão de crédito)
                                      </Text>

                                      
                                    </>
                                  )}
                              </>
                            )}
                            {service.discount == 1 ? (
                              <>
                                <Text fontSize="sm">
                                  Valor Total do Serviço:{" "}
                                  <Text as="span" fontWeight="bold">
                                    {service.total_budget_order?.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                                  </Text>{" "}
                                  (Cartão de crédito)
                                </Text>

                                <Text fontSize="sm">
                                  Valor Total do Serviço:{" "}
                                  <Text as="span" fontWeight="bold">
                                    {service.total_budget_order_pix?.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                                  </Text>{" "}
                                  (Pix ou Boleto)
                                </Text>

                                <Text fontSize="md" fontWeight="bold">
                                  Valor Total do Serviço com Desconto:{" "}
                                  <Text as="span" color="green.600">
                                    {service.total_budget_order_discount?.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                                  </Text>{" "}
                                  (Cartão de crédito)
                                </Text>

                                <Text fontSize="md" fontWeight="bold">
                                  Valor Total do Serviço com Desconto:{" "}
                                  <Text as="span" color="blue.600">
                                    {service.total_budget_order_discount_pix?.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                                  </Text>{" "}
                                  (PIX ou Boleto)
                                </Text>

                                {service.fast_delivery && (
                                  <Text fontSize="md" fontWeight="bold">
                                    Dias Reduzidos:{" "}
                                    <Text as="span" color="green.600">
                                      {service.reduced_days_fast}
                                    </Text>
                                  </Text>
                                )}
                              </>
                            ) : (
                              <>
                                <Text fontSize="md" fontWeight="bold">
                                  Valor Total do Serviço:{" "}
                                  <Text as="span" color="green.600">
                                    {service.total_budget_order?.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                                  </Text>{" "}
                                  (Cartão de crédito)
                                </Text>

                                <Text fontSize="md" fontWeight="bold">
                                  Valor Total do Serviço:{" "}
                                  <Text as="span" color="blue.600">
                                    {service.total_budget_order_pix?.toLocaleString(
                                      "pt-BR",
                                      {
                                        style: "currency",
                                        currency: "BRL",
                                      }
                                    )}
                                  </Text>{" "}
                                  (PIX ou Boleto)
                                </Text>

                                {service.fast_delivery && (
                                  <Text fontSize="md" fontWeight="bold">
                                    Dias Reduzidos:{" "}
                                    <Text as="span" color="green.600">
                                      {service.reduced_days_fast}
                                    </Text>
                                  </Text>
                                )}
                              </>
                            )}
                          </VStack>
                        )}
                    </VStack>
                  </Box>
                </Box>
              ))}
              <Text>Adicionar mais um serviço?</Text>
              <IconButton
                aria-label="Adicionar serviço"
                icon={<AddIcon />}
                size="sm"
                colorScheme="green"
                alignSelf="flex-start"
                onClick={handleAddService}
              />
            </VStack>
          </form>

          <Box mt={4} />
          <Box mt={2}>
            <Button colorScheme="blue" onClick={() => calculateTotal()}>
              Calcular total
            </Button>
          </Box>
          {totalBudget > 0 && totalBudgetPix > 0 ? (
            <>
              <Box my={5}>
                Orçamento Total:{" "}
                {totalBudget?.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}{" "}
                ou em até {numberParcelas}x de{" "}
                {precoParcelamento?.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}{" "}
                (Cartão de crédito)
              </Box>
              <Box my={5}>
                Orçamento Total:{" "}
                {totalBudgetPix?.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}{" "}
                (PIX ou Boleto)
              </Box>
            </>
          ) : (
            ""
          )}
          <Flex marginTop={"10px"} gap={4}>
            <FormControl isInvalid={errors.deadline} isRequired flex="1">
              <FormLabel>Prazo Final de Entrega (Dias)</FormLabel>
              <Input
                type="number"
                value={deadline}
                onChange={(e) => setDeadline(e.target.value)}
              />
              <FormErrorMessage>Campo obrigatório</FormErrorMessage>
            </FormControl>
            {fastDelivery == 1 ? (
              <FormControl isInvalid={errors.deadline} isRequired flex="1">
                <FormLabel>Dias Reduzidos</FormLabel>
                <Input
                  type="number"
                  value={deadline}
                  onChange={(e) => setDeadline(e.target.value)}
                />
                <FormErrorMessage>Campo obrigatório</FormErrorMessage>
              </FormControl>
            ) : (
              <Box flex="1" />
            )}
          </Flex>
          {totalBudget > 0 ? (
            <Button colorScheme="green" my="5" onClick={handleGenerateData}>
              {" "}
              Criar Orçamento
            </Button>
          ) : (
            ""
          )}
        </Box>
      </Container>
          
    </>
  );
}
